import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tab, Tabs } from 'foundations-components/transitional/components/Tabs';
import { useContext } from 'react';
import { ASSOCIATE_TAB_ID, CREATE_TAB_ID } from '../../../constants/associations';
import { toObjectTypes } from '../../../constants/types';
import { AppContext } from '../../../contexts/app/context';
import { AssociationModalPropsContext } from '../../../contexts/associationModal/PropsContext';
import CreateNewTab from './CreateNewTab';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function AssociationModalTabs({
  onSelectedTabChange,
  associateCrmObjectComponent,
  isApiOutageError,
  setIsApiOutageError
}) {
  const {
    crmObjectType
  } = useContext(AssociationModalPropsContext);
  const {
    appName
  } = useContext(AppContext);
  const onSelectedTabChangeHandler = event => {
    onSelectedTabChange(event.target.value);
  };
  if (crmObjectType === toObjectTypes.meeting) return associateCrmObjectComponent;
  if (!associateCrmObjectComponent) {
    return /*#__PURE__*/_jsx(CreateNewTab, {
      isApiOutageError: isApiOutageError,
      setIsApiOutageError: setIsApiOutageError
    });
  }
  return /*#__PURE__*/_jsxs(Tabs, {
    defaultSelected: ASSOCIATE_TAB_ID,
    fill: true,
    onSelectedChange: onSelectedTabChangeHandler,
    use: "enclosed",
    "data-test-id": `${appName}-tabs`,
    children: [/*#__PURE__*/_jsx(Tab, {
      tabId: CREATE_TAB_ID,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "associationsPanel.tabs.create.title"
      }),
      "data-test-id": `${appName}-create-tab`,
      children: /*#__PURE__*/_jsx(CreateNewTab, {
        isApiOutageError: isApiOutageError,
        setIsApiOutageError: setIsApiOutageError
      })
    }), /*#__PURE__*/_jsx(Tab, {
      tabId: ASSOCIATE_TAB_ID,
      "data-test-id": `${appName}-associate-tab`,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "associationsPanel.tabs.associate.title"
      }),
      children: associateCrmObjectComponent
    })]
  });
}
export default AssociationModalTabs;